import moment from "moment";

export enum PaymentTransactionTypeIds {
  Service = 1,
  Refund = 2,
  Credit = 3,
  Subscription = 4,
  Other = 5,
}

export enum RefundTransactionReasons {
  SubscriptionPaymentTransactionRefundReason = "SubscriptionPaymentTransactionRefundReason",
}

export function defaultFilteredTransactionTypes() {
  return [
    PaymentTransactionTypeIds.Service,
    PaymentTransactionTypeIds.Refund,
    PaymentTransactionTypeIds.Credit,
    PaymentTransactionTypeIds.Subscription,
    PaymentTransactionTypeIds.Other,
  ];
}

export function defaultBillingDateRange() {
  return {
    startDate: moment()
      .subtract(30, "days")
      .format(),
    endDate: moment()
      .format(),
  };
}

export enum PaymentTransactionStatusId {
  Pending = 1,
  Processed = 2,
  Failed = 3,
  Canceled = 4,
  Partial = 5,
  Review = 6,
}

export enum RefundTransactionId {
  Pending = 1,
  Processed = 2,
  Failed = 3,
  Canceled = 4,
  Partial = 5,
  Review = 6,
}
export interface PaymentTransactionData {
  paymentInstrumentId: number;
  amount: number;
  personId?: number;
  tripId?: number;
  subscriptionId?: number;
}
export type BillingHistoryParams = {
  StartDate: string;
  EndDate: string;
  PageOffset: number;
  PageSize: number;
  CustomerPersonId?: number;
  PaymentTransactionTypeIds?: any;
  PaymentTransactionStatusIds?: Array<number>;
  PaymentGatewayTypeId?: number;
  PaymentInstrumentId?: number;
};
export interface ITransactionDetails {
  serviceType: string;
  bookingId: number;
  requestAssignmentId: number;
  serviceUser: string;
  serviceUserPersonId: number;
  paymentTransactionId: number;
  refundedTransactionId: number;
  customerPersonId: number;
  createdByPersonId: number;
  paymentInstrumentId: number;
  paymentInstrumentName: string;
  amount: number;
  tripId: number;
  tripDate: string;
  subscriptionId: number;
  subscriptionName: string;
  details: string;
  notes: string;
  failureReason: string;
  createdOn: string;
  editedOn: string;
  paymentGatewayTypeId: number;
  paymentGatewayTypeName: string;
  paymentTransactionTypeId: number;
  paymentTransactionTypeName: string;
  paymentTransactionStatusId: number;
  paymentTransactionStatusName: string;
  refundReasonId: number;
  refundReasonName: string;
  refundTransactionId: number;
  refundTransactionStatusId: number;
  refundTransactionStatusName: string;
}

export const defaultTransactionDetails = {
  serviceType: "",
  bookingId: 0,
  requestAssignmentId: 0,
  serviceUser: "",
  serviceUserPersonId: 0,
  paymentTransactionId: 0,
  refundedTransactionId: 0,
  customerPersonId: 0,
  createdByPersonId: 0,
  paymentInstrumentId: 0,
  paymentInstrumentName: "",
  amount: 0,
  tripId: 0,
  tripDate: "",
  subscriptionId: 0,
  subscriptionName: "",
  details: "",
  notes: "",
  failureReason: "",
  createdOn: "",
  editedOn: "",
  paymentGatewayTypeId: 0,
  paymentGatewayTypeName: "",
  paymentTransactionTypeId: 0,
  paymentTransactionTypeName: "",
  paymentTransactionStatusId: 0,
  paymentTransactionStatusName: "",
  refundReasonId: 0,
  refundReasonName: "",
  refundTransactionId: 0,
  refundTransactionStatusId: 0,
  refundTransactionStatusName: "",
};
export interface RefundTransactionRequestBody {
  amount: number;
  reasonId: number;
  notes: string;
}

export type RefundReasons = {
  value: number;
  label: string;
};

export const excelColumns = [
  {
    title: "Transaction Date",
    dataIndex: "createdOn",
    key: "createdOn",
    width: 300,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 300,
  },
  {
    title: "Transaction Type",
    dataIndex: "paymentTransactionTypeName",
    key: "paymentTransactionTypeName",
    width: 300,
  },
  {
    title: "Payment Type 1",
    dataIndex: "paymentInstrumentName",
    key: "paymentInstrumentName",
    width: 300,
  },
  {
    title: "Payment Type 2",
    dataIndex: "paymentType2",
    key: "paymentType2",
    width: 300,
  },
  {
    title: "Transaction ID",
    dataIndex: "paymentTransactionId",
    key: "paymentTransactionId",
    width: 300,
  },
  {
    title: "Details",
    dataIndex: "notes",
    key: "notes",
    width: 300,
  },
  {
    title: "Type",
    dataIndex: "serviceType",
    key: "serviceType",
    width: 300,
  },
  {
    title: "Service User",
    dataIndex: "serviceUser",
    key: "serviceUser",
    width: 300,
  },
  {
    title: "Trip ID",
    dataIndex: "tripId",
    key: "tripId",
    width: 300,
  },
  {
    title: "Booking ID",
    dataIndex: "bookingId",
    key: "bookingId",
    width: 300,
  },
  {
    title: "Refunded Transaction ID",
    dataIndex: "refundedTransactionId",
    key: "refundedTransactionId",
    width: 300,
  },
];
